interface DegressiveGridProps {
  summary: string;
  headers: [string, string, string];
  rows: [string, string, string][];
  /** Explains that the rates are marginal, not applied to the whole quantity. */
  note?: string;
}

/** Collapsible volume-discount table shown under a metered price. */
const DegressiveGrid = ({ summary, headers, rows, note }: DegressiveGridProps) => (
  <details className="text-xs text-muted-foreground">
    <summary className="cursor-pointer font-semibold transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card">
      {summary}
    </summary>
    <div className="pt-2">
      <table className="w-full text-left">
        <thead>
          <tr className="font-bold text-foreground/90">
            {headers.map((header) => (
              <th key={header} scope="col" className="py-0.5 pl-4 font-bold first:pl-0">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([range, ...values]) => (
            <tr key={range}>
              <th scope="row" className="py-0.5 font-normal">
                {range}
              </th>
              {values.map((value, index) => (
                <td key={index} className="py-0.5 pl-4">
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {note && <p className="pt-2 italic">{note}</p>}
    </div>
  </details>
);

export default DegressiveGrid;
